module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"message":"See what contacts look like in Keap.","cta":"Add sample contacts"}}')
  delete Component.options._Ctor
}
